import React from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { FaGamepad, FaRegHandRock, FaMask, FaBook, FaCheck } from "react-icons/fa";
import FormField from "../components/FormField";
import { cn } from "../lib/utils";

const DOMAINS = [
  { value: "Cosplay",               icon: FaMask,    label: "Cosplay",                field: "cosplay",           fieldLabel: "Tes cosplays ?" },
  { value: "Culture Geek",          icon: FaGamepad, label: "Culture Geek",           field: "cultureGeek",       fieldLabel: "Ton domaine favori ?" },
  { value: "Culture de l'imaginaire", icon: FaBook,  label: "Culture de l'imaginaire", field: "cultureImaginaire", fieldLabel: "Univers préférés ?" },
];

const fieldLabelClass = "flex items-center gap-2 text-sm font-semibold text-foreground select-none";

export const Step2 = () => {
  const { values } = useFormikContext();
  const activeDomains = DOMAINS.filter((d) => values.domainePratique?.includes(d.value));

  return (
    <div className="flex flex-col gap-3 step-enter">
      <div>
        <h2 className="text-base font-bold text-foreground">Utile à l'association</h2>
        <p className="text-xs text-muted-foreground mt-0.5">
          Ces informations nous aident à vous intégrer à notre communauté.
        </p>
      </div>

      {/* Domaine de pratique — en avant, cartes lisibles plutôt que des puces */}
      <div className="flex flex-col gap-1.5">
        <label className={fieldLabelClass}>
          Domaine de pratique <span style={{ color: "var(--req)" }} className="font-bold">*</span>
        </label>
        <div className="grid grid-cols-3 gap-2">
          {DOMAINS.map(({ value, icon: Icon, label }) => (
            <Field key={value} name="domainePratique">
              {({ field, form }) => {
                const checked = field.value?.includes(value);
                return (
                  <label
                    className="relative flex flex-col items-center gap-1.5 py-2.5 px-1.5 rounded-xl border cursor-pointer transition-all duration-150 select-none text-center"
                    style={checked ? { borderColor: "var(--acc)", background: "var(--acc-soft)" } : { borderColor: "var(--line-2)" }}
                    onClick={() => {
                      const cur = field.value || [];
                      form.setFieldValue("domainePratique", checked ? cur.filter((v) => v !== value) : [...cur, value]);
                    }}
                  >
                    {checked && (
                      <span
                        className="absolute top-1.5 right-1.5 w-4 h-4 rounded-full flex items-center justify-center"
                        style={{ background: "var(--acc)", color: "var(--acc-fg)" }}
                      >
                        <FaCheck className="h-2 w-2" />
                      </span>
                    )}
                    <div
                      className="w-8 h-8 rounded-full flex items-center justify-center"
                      style={{ background: checked ? "var(--acc)" : "var(--acc-soft)" }}
                    >
                      <Icon className="h-3.5 w-3.5" style={{ color: checked ? "var(--acc-fg)" : "var(--acc)" }} />
                    </div>
                    <span className="text-[11px] font-semibold leading-tight" style={checked ? { color: "var(--acc)" } : undefined}>
                      {label}
                    </span>
                  </label>
                );
              }}
            </Field>
          ))}
        </div>
        <ErrorMessage name="domainePratique" component="p" className="field-err" />
      </div>

      {/* Détails — juste après les domaines concernés, sur une ligne courte */}
      {activeDomains.length > 0 && (
        <div className={cn("grid grid-cols-1 gap-3", activeDomains.length > 1 ? "sm:grid-cols-2 lg:grid-cols-3" : "")}>
          {activeDomains.map(({ field, fieldLabel, icon }) => (
            <FormField key={field} name={field} label={fieldLabel} icon={icon} />
          ))}
        </div>
      )}

      <FormField
        name="motivation"
        label="Quelles sont vos motivations ?"
        icon={FaRegHandRock}
        as="textarea"
        rows={3}
        required
      />
    </div>
  );
};
